export const FOOTER_CONTROL_MARGIN = 180;
export const ROW_HEIGHT = 32;
export const MIN_FOOTER_HEIGHT = FOOTER_CONTROL_MARGIN + ROW_HEIGHT;
export const INITIAL_FOOTER_HEIGHT = 295;
export const INITIAL_FOOTER_HEIGHT_AGGREGATIONS = 320;
export const getMaxHeight = () => window.innerHeight - MIN_FOOTER_HEIGHT;
export const getInitialMaxHeight = () => window.innerHeight * 0.4;
export const MIN_FUNCTION_BOX_SECTION_HEIGHT = 410;
